import { environment } from 'environments/environment'
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, finalize, tap } from 'rxjs';
import { CurrencyCode } from 'models/payment.interfaces';
import { changeLimitsRequest, changeLimitsResponse, sepaAccountsLimitsResponse } from './account.interface';

export interface AccountDetailsDataItem {
  title: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

  private readonly isLoadingSource$ = new BehaviorSubject<boolean>(false);
  public isLoading$: Observable<boolean> = this.isLoadingSource$.asObservable();

  constructor(private http: HttpClient) {}

  getAccountById(id: string, currency?: CurrencyCode): Observable<AccountDetailsDataItem[]> {
    this.isLoadingSource$.next(true);
    let url = environment.baseApi + `/v1/accounts/${id}/details`;
    if (currency) {
      url+=`?currency=${currency}`;
    }
    return this.http.get<AccountDetailsDataItem[]>(url).pipe(
      finalize(() => this.isLoadingSource$.next(false)),
    );
  }

  getAccountsLimits(id: number): Observable<sepaAccountsLimitsResponse> {
    this.isLoadingSource$.next(true);
    let url = environment.baseApi + `/v1/accounts/${id}/limits`;
    
    return this.http.get<sepaAccountsLimitsResponse>(url).pipe(
      catchError((error) => {
        
        throw error;
      }),
      finalize(() => this.isLoadingSource$.next(false)),
    );
  }

  changeAccountLimits(payload: changeLimitsRequest): Observable<changeLimitsResponse> {
    this.isLoadingSource$.next(true);
    let url = environment.baseApi + `/v1/accounts/limits`;

    return this.http.put<changeLimitsResponse>(url, payload).pipe(
      catchError((error) => {
        
        throw error;
      }),
      finalize(() => this.isLoadingSource$.next(false)),
    );
  }
}
